export default "__VITE_PUBLIC_ASSET__ddfd8fdc__"